import { UseConstant } from "../../libraries/UseConstant";

export const GetUserTypeOptionByValue = (inputVal) => {
    const { constant } = UseConstant();
    const { USER_TYPES } = constant;

    const rtn = USER_TYPES.filter((user_type) => {
        return user_type.key === inputVal;
    });

    if(rtn.length > 0) {
        return rtn[0].val;
    }
    return '';
}

export const GetContractTypeOptionByValue = (inputVal) => {
    const { constant } = UseConstant();
    const { CONTRACT_TYPES } = constant;

    const rtn = CONTRACT_TYPES.filter((item) => {
        return item.key === inputVal;
    });

    if(rtn.length > 0) {
        return rtn[0].val;
    }
    return '';
}

export const GetSexOptionByValue = (inputVal) => {
    const { constant } = UseConstant();
    const { SEX } = constant;

    const rtn = SEX.filter((item) => {
        return item.key === inputVal;
    });

    if(rtn.length > 0) {
        return rtn[0].val;
    }
    return '';
}

export const GetProjectTypeOptionByValue = (inputVal) => {
    const { constant } = UseConstant();
    const { PROJECT_TYPES } = constant;

    const rtn = PROJECT_TYPES.filter((item) => {
        return item.key === inputVal;
    });

    if(rtn.length > 0) {
        return rtn[0].val;
    }
    return '';
}